import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
// ignore-string-externalization
import React from "react";
import { BrowserRouter } from "./BrowserRouter";
import { StaticRouter } from "./StaticRouter";
/** Add support for react-router to a next.js App */ export function withReactRouter(App) {
    var ReactRouterApp = function ReactRouterApp(props) {
        if (process.browser) {
            return /*#__PURE__*/ _jsx(BrowserRouter, {
                children: /*#__PURE__*/ _jsx(App, _object_spread({}, props))
            });
        }
        return /*#__PURE__*/ _jsx(StaticRouter, {
            children: /*#__PURE__*/ _jsx(App, _object_spread({}, props))
        });
    };
    Object.assign(ReactRouterApp, App);
    return ReactRouterApp;
}
